import React, {useEffect} from 'react';
import {Flex, Tag} from "antd";
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import {useDispatch, useSelector} from "react-redux";
import {getAllTeachersPageable} from "../../../../../store/slices/TeachersListSlice";
import {changeCurrentPage} from "../../../../../store/slices/tableController/TeachersListTableController";
import MyTable from "../../../../../components/Table/MyTable";
import {LocalName} from "../../../../../utils/LocalName";

const TeachersList = () => {
    const dispatch = useDispatch();
    const {teachers, isLoading, hasMore, error} = useSelector(state => state.teachersList);
    const {currentPage, pageSize} = useSelector(state => state.teachersListTableController);

    useEffect(() => {
        dispatch(getAllTeachersPageable({
            page: currentPage,
            limit: pageSize,
            isGroupsNeeded: true
        }));
    }, []);

    const fetchData = async (params) => {
        return dispatch(getAllTeachersPageable({
            ...params,
            isGroupsNeeded: true
        }));
    }

    const saveCurrentPageSettings = (page, pageSize) => {
        dispatch(changeCurrentPage({page: page, pageSize: pageSize}));
    };

    const columns = [
        {
            title: <span style={{fontWeight: 600}}><IntlMessage id={'fullName'}/> / <IntlMessage
                id={'username'}/></span>,
            render: (_, record) => (
                <p>{record.fullName}</p>
            ),
            width: '30%',
        },
        {
            title: <span style={{fontWeight: 600}}><IntlMessage id={'email'}/></span>,
            render: (_, record) => (
                <p>{record.email}</p>
            ),
            width: '25%',
        },
        {
            title: <span style={{fontWeight: 600}}><IntlMessage id={'groups'}/></span>,
            render: (_, record) => (
                <Flex gap={5} wrap="wrap">
                    {record.groups && record.groups.length > 0 ? (
                        record.groups.map((group, index) => (
                            <Tag key={index} color="green">
                                {LocalName.getName(group)} {group.number}
                            </Tag>
                        ))
                    ) : (
                        <Tag color="orange"><IntlMessage id={'noGroups'}/></Tag>
                    )}
                </Flex>
            ),
            width: '45%',
        },
    ];

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyTable
                isLoading={isLoading}
                dataSource={teachers}
                columns={columns}
                fetchData={fetchData}
                saveCurrentPage={saveCurrentPageSettings}
                initialPage={currentPage}
                initialPageSize={pageSize}
                hasMore={hasMore}
            />
        </Flex>
    );
};

export default TeachersList;